// Delivery address for delivery ("online") orders; empty string otherwise
export const getDeliveryAddress = (order: {
  choice?: string;
  location?: { name?: string } | null;
  metadata?: unknown;
}) => {
  if (order.choice?.toLowerCase() !== "online") return "";
  const locationName = order.location?.name?.trim();
  if (locationName) return locationName;

  const metadata = order.metadata as Record<string, unknown> | undefined;
  if (!metadata || typeof metadata !== "object") return "";
  const dropoff = metadata.dropoff as Record<string, unknown> | undefined;
  const candidates = [
    metadata.dropoff_address,
    metadata.dropoffAddress,
    metadata.delivery_address,
    metadata.deliveryAddress,
    dropoff && typeof dropoff === "object" ? dropoff.address : undefined,
    dropoff && typeof dropoff === "object" ? dropoff.full_address : undefined,
  ];
  const found = candidates.find(
    (value) => typeof value === "string" && value.trim().length > 0,
  );
  return typeof found === "string" ? found.trim() : "";
};
